<script>
import WebsiteLogo from "@/components/icons/WebsiteLogo.vue";
// import WFLeft from "@/layouts/website/components/WH/WFLeft.vue";
import WNav from "@/layouts/website/components/WH/WNav.vue";
import WFRight from "@/layouts/website/components/WH/WFRight.vue";
import WHMoreMenu from "@/layouts/website/components/WH/WHMoreMenu.vue";
import {
  APP_MENU_ITEM_HEIGHT,
  APP_MENU_ITEM_WIDTH,
  APP_NAV_HEIGHT,
} from "@/config/app.config";

export default {
  name: "WebsiteHeader",
  components: {WHMoreMenu, WebsiteLogo, WNav, WFRight},
  data() {
    return {
      window_width: window.innerWidth,
    }
  },
  computed: {
    app_nav_height: function () {
      return APP_NAV_HEIGHT;
    },
    app_menu_item_width: function () {


      if (this.window_width < 1566 && this.window_width >= 1399) {
        return "6em"
      }

      if (this.window_width < 1399) {
        return "5em"
      }

      return APP_MENU_ITEM_WIDTH;
    },
    app_menu_item_height: function () {
      return APP_MENU_ITEM_HEIGHT + "px";
    },
  },
  mounted() {
    window.addEventListener("resize", this.handledResize)
  },
  methods: {
    handledResize() {
      this.window_width = window.innerWidth
    }
  }
};
</script>

<template>
  <div
      class="website-header"
      :style="{
      '--app-header-nav-height': app_nav_height,
      '--app-header-menu-item-width': app_menu_item_width,
      '--app-header-menu-item-height': app_menu_item_height,
    }"
  >
    <div class="website-header-main">
      <WebsiteLogo/>
      <!--      <WFLeft/>-->
      <WNav/>
      <WFRight/>
    </div>
    <WHMoreMenu/>
  </div>
</template>

<style lang="scss" scoped>
.website-header-main {
  padding-top: 15px;
  box-sizing: content-box;
  height: var(--app-header-nav-height);
}
</style>
